import React, { useState } from 'react';
import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter, BsYoutube } from 'react-icons/bs';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';


const Hadear = () => {
  const [ismobile, setIsmobile] = useState(0);

  return (
    <>

      <div className="topbar">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-7">
              {/* Topbar Contact Information Start */}
              <div className="topbar-contact-info">
                <ul>
                  <li><img src="./assets/images/icon-phone-white.svg" alt /> <span>Phone Number:</span> <a href="tel:+91 9516839231">+91 9516839231</a></li>
                  <li><img src="./assets/images/icon-mail-white.svg" alt /> <span>Email Address:</span> <a href="mailto:info@solarwesta.com">info@solarwesta.com</a></li>
                </ul>
              </div>
              {/* Topbar Contact Information End */}
            </div>
            <div className="col-lg-5 col-md-5">
              {/* Topbar Social Links Start */}
              <div className="topbar-social-links">
                <p>Follow Us On Social:</p>
                <ul>
                  <li><Link to="https://www.instagram.com/solar_westa?igsh=Zmg3eWh0ajhhYTlr" target="_blank"><i className="fa-brands fa-instagram" /></Link></li>
                  <li><Link to="https://www.facebook.com/solarwesta"><i className="fa-brands fa-facebook-f" target="_blank" /></Link></li>
                  <li><a to="#"><i className="fa-brands fa-youtube" target="_blank" /></a></li>
                </ul>
              </div>
              {/* Topbar Social Links End */}
            </div>
          </div>
        </div>
      </div>


      <nav className="navbar navbar-expand-lg sticky-top">
        <div className="container">
          <Link className="navbar-brand">
            <div className="logo-wrapper" style={{ marginBottom: "-39px" }}>
              <Link className='d-flex justify-content-center align-items-center' to="/">
                <img style={{ marginTop: "-65px" }} src="./assets/solar/solarwesta_1.webp" className="img-fluid" alt="Edusquad" />
              </Link>
            </div>
          </Link>
          <div className={ismobile ? "moblink" : "desklink"} onClick={() => setIsmobile(false)} style={{ marginRight: "94px" }}>
            <ul>
              <Link className=" text-decoration-none" to="/">
                <li >Home</li>
              </Link>
              <Link className=" text-decoration-none" to="/about">
                <li className='li' >About Us</li>
              </Link>

              <Link className=" text-decoration-none" to="/services">
                <li> Our Services</li>
              </Link>
              <Link className=" text-decoration-none" to="/contact-us">
                <li> Our Career</li>
              </Link>
              <Link className=" text-decoration-none" to="/blog">
                <li> Blog & Updates</li>
              </Link>
              <Link className=" text-decoration-none" to="/gallery">
                <li> Our Gallery</li>
              </Link>
              <Link className=" text-decoration-none" to="/contact-us">
                <li> Contact Us</li>
              </Link>
            </ul>
          </div>

          <button className='vavbutn' onClick={() => setIsmobile(!ismobile)} style={{ marginBottom: "60px" }}>
            {ismobile ? < IoMdClose /> : < GiHamburgerMenu />}
          </button>
        </div>
      </nav>
    </>
  )
}
export default Hadear